export default {"src":"/_next/static/media/check-circle.23da6f76.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};